<template>
  <div id="app">
    <el-container style="height: 920px; border: 1px solid #eee">
      <el-aside v-if="!viewData.isLoginPage" width="200px" style="background-color: rgb(238, 241, 246)">
        <el-menu :default-openeds="openeds">
          <el-submenu index="1">
            <template slot="title"><i class="el-icon-finished"></i>签到记录管理</template>
            <el-menu-item-group>
              <el-menu-item index="1-1" @click="push('/log-time/')">签到记录(按次)</el-menu-item>
              <el-menu-item index="1-2" @click="push('/log-day/')">签到记录(按天)</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="2">
            <template slot="title"><i class="el-icon-office-building"></i>上下班打卡记录</template>
            <el-menu-item-group>
              <el-menu-item index="2-1" @click="push('/da-ka/')">上下班打卡记录</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="3">
            <template slot="title"><i class="el-icon-user"></i>员工管理</template>
            <el-menu-item-group>
              <el-menu-item index="3-1" @click="push('/yg-list/')">员工列表</el-menu-item>
              <el-menu-item index="3-2" @click="push('/add-yg/')">添加员工</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="4">
            <template slot="title"><i class="el-icon-setting"></i>事件管理</template>
            <el-menu-item-group>
              <el-menu-item index="4-1" @click="push('/action-list/')">事件列表</el-menu-item>
              <el-menu-item index="4-2" @click="push('/add-action/')">添加事件</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="5">
            <template slot="title"><i class="el-icon-setting"></i>管理员设置</template>
            <el-menu-item-group>
              <el-menu-item index="5-1" @click="push('/system-set/')">全局设置</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-container>
        <el-header v-if="!viewData.isLoginPage" style="text-align: right; font-size: 18px">
          <el-row>
            <el-col :span="12"><div class="grid-content" style="text-align: left;">{{viewData.mtitle}}</div></el-col>
            <el-col :span="12">
              <div class="grid-content">
                <span>{{ adminUserName }}</span> | 
                <span class="logout" @click="handleLogout">退出</span>
              </div>
            </el-col>
          </el-row>
        </el-header>
        <router-view @getMessage="showMsg"></router-view>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'App',
  components: {
  },
  data () {
    return {
      openeds: ['1', '2'],
      adminUserName: '',
      viewData: {
        mtitle: '签到管理',
        isLoginPage: false,
      }
    }
  },
  methods: {
    push(url) {
      this.$router.push(url)
    },
    showMsg(val) {
      this.viewData = val
    },
    handleLogout() {
      axios.get('/api/adminLogout')
      .then((response)=> {
        if(response.data.code == 0) {
          window.location.href =  '/#/admin-login/'
        }
      })
    }
  },
  mounted () {
    if(!this.viewData.isLoginPage) {
      var _this = this
      axios.get('/api/admin/systemSet')
      .then((response)=> {
        if(response.data.code == 0) {
            _this.adminUserName = response.data.data.username
        } else {
            _this.$message({
                type: 'error',
                message: response.data.msg
            })
        }
      })
      .catch(function (error) {
        if(error.response.status == 404 && error.response.data.code == 99) {
          _this.$message({
            type: 'error',
            message: '您还未登录'
          })
          window.location.href =  '/#/admin-login/'
        }
      })
    }
  }
}
</script>

<style>
  .el-header {
    background-color: #409eff;
    color: #fff;
    line-height: 60px;
  }
  
  .el-aside {
    color: #fff;
  }

  a {
    text-decoration: none;
  }
  .el-icon-setting {
    color: #fff;
  }
  .logout {
    text-decoration: underline;
    cursor: pointer;
    font-size: 16px;
  }
</style>
